var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "gh-accordionHeader",
    on: {
      "click": _vm.accordionToggle
    }
  }, [_c('button', {
    attrs: {
      "aria-expanded": _vm.active ? 'true' : 'false'
    }
  }, [_vm._t("default")], 2), _c('div', [_c('icon-chevron', {
    staticClass: "gh-icon",
    class: {
      'gh-inverted': _vm.active
    }
  })], 1)]), _vm.active ? _c('div', {
    staticClass: "gh-accordionContent"
  }, [_vm._t("content")], 2) : _vm._e()]);
};
var staticRenderFns = [];
export { render, staticRenderFns };